module.exports = __webpack_public_path__ + "img/icon-search.e8f356ae.svg";